<template>
  <a-card :bordered="false">
    <a-row :gutter="8">
      <a-col :span="5">
        <a-input style="margin-bottom: 8px" v-model="searchValue" @change="handleChange" ref="searchInput">
          <a-icon slot="prefix" type="search" />
          <a-icon v-if="searchValue" slot="suffix" type="close-circle" @click="emitEmpty" />
        </a-input>
        <a-tree
          v-if="deptTree.length > 0"
          :treeData="deptTree"
          @expand="onExpand"
          :expandedKeys="expandedKeys"
          :autoExpandParent="autoExpandParent"
          @select="handleSelect"
        >
          <template slot="title" slot-scope="{ title }">
            <span v-if="title.indexOf(searchValue) > -1">
              {{ title.substr(0, title.indexOf(searchValue)) }}
              <span style="color: red">{{ searchValue }}</span>
              {{ title.substr(title.indexOf(searchValue) + searchValue.length) }}
            </span>
            <span v-else>{{ title }}</span>
          </template>
        </a-tree>
      </a-col>
      <a-col :span="19">
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :span="6">
                <a-form-item label="用户名">
                  <a-input v-model="queryParam.loginName" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="姓名">
                  <a-input v-model="queryParam.userName" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="手机号">
                  <a-input v-model="queryParam.phonenumber" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="状态">
                  <a-select v-model="queryParam.status">
                    <a-select-option :value="''">全部</a-select-option>
                    <a-select-option :value="'0'">正常</a-select-option>
                    <a-select-option :value="'1'">禁用</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col style="float: right">
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
              </a-col>
            </a-row>
            <a-divider />
            <a-row :gutter="8">
              <a-button style="float: right" v-if="addEnable" type="primary" icon="plus" @click="$refs.modal.add()"
                >新增</a-button
              >
            </a-row>
          </a-form>
        </div>
        <div class="table-operator">
          <!-- <a-button type="primary" icon="plus" @click="$refs.modal.add()">新建</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0"> -->

          <a-dropdown v-if="removeEnable && selectedRowKeys.length > 0">
            <!-- <a-menu slot="overlay">
          <a-menu-item key="1"><a-icon type="delete" />删除</a-menu-item>
          <a-menu-item key="2"><a-icon type="lock" />禁用</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button> -->
            <a-button type="danger" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button>
          </a-dropdown>
        </div>
        <s-table
          size="default"
          ref="table"
          rowKey="userId"
          :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :columns="columns"
          :data="loadData"
          bordered
          :scroll="{ x: '500px' }"
        >
          <span slot="status" slot-scope="text, record">
            <a-switch :checked="record.status == '0'" @change="onChangeStatus(record)" />
          </span>
          <span slot="action" slot-scope="text, record">
            <a v-if="editEnabel" @click="handleEdit(record)">编辑</a>
            <a-divider type="vertical" />
            <a v-if="removeEnable" @click="delByIds([record.userId])">删除</a>
            <a-divider type="vertical" />
            <a v-if="resetPwdEnabel" @click="resetPwd(record)">重置密码</a>
            <a-divider type="vertical" />
            <!-- <a v-if="lockEnable" @click="lockAuthority(record)">锁企权限</a> -->
            <a @click="lockAuthority(record)">锁企权限</a>
          </span>
        </s-table>
      </a-col>
    </a-row>
    <a-modal
      destroyOnClose="true"
      title="锁企权限"
      v-model="visible1"
      :confirm-loading="confirmLoading"
      @ok="handleSubmit"
      @cancel="handleCancel"
      width="1000px"
    >
      <a-transfer
        :titles="['待选择', '已选择']"
        :data-source="lockData"
        show-search
        :filter-option="filterOption"
        :target-keys="targetKeys"
        :render="(item) => item.title"
        @change="lockChange"
        :listStyle="{ height: '500px', width: '400px', margin: '0px 16px 0px 30px' }"
      />
    </a-modal>
    <user-modal ref="modal" @ok="handleOk" :deptTree="deptTree" />
    <user-pwd-modal ref="pwdmodal" />
  </a-card>
</template>

<script>
import { Tree } from 'ant-design-vue'
import { STable, STree } from '@/components'
import { getUserList, getDeptList, delUser, changUserStatus } from '@/api/system'
import UserModal from './modules/UserModal'
import UserPwdModal from './modules/UserPwdModal'
import pick from 'lodash.pick'
import { checkPermission } from '@/utils/permissions'
import { getEnterpriseSelectCombox, addUserPermissionOfEnterprise } from '@/api/enterprise/management'
export default {
  name: 'TableList',
  components: {
    Tree,
    STree,
    STable,
    UserModal,
    UserPwdModal,
  },
  data() {
    return {
      userId: undefined,
      visible: false,
      visible1: false,
      confirmLoading: false,
      lockData: [],
      targetKeys: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '操作',
          width: '80px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '用户名',
          dataIndex: 'loginName',
          align: 'center',
        },
        {
          title: '客服名',
          dataIndex: 'userName',
          align: 'center',
        },
        {
          title: '手机号',
          dataIndex: 'phonenumber',
          align: 'center',
        },
        {
          title: '姓名',
          dataIndex: 'realName',
          align: 'center',
        },
        {
          title: '状态',
          dataIndex: 'status',
          align: 'center',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
          sorter: true,
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return getUserList(Object.assign(parameter, this.queryParam)).then((res) => {
          // console.log('getUserList', res)
          return res
        })
      },
      searchValue: '',
      deptTree: [],
      expandedKeys: [],
      dataList: [],
      autoExpandParent: true,
      selectedRowKeys: [],
      selectedRows: [],
      addEnable: checkPermission('system:user:add'),
      editEnabel: checkPermission('system:user:edit'),
      resetPwdEnabel: checkPermission('system:user:resetPwd'),
      removeEnable: checkPermission('system:user:remove'),
      // lockEnable: checkPermission('system:user:lock'),
    }
  },
  created() {
    getDeptList().then((res) => {
      const data = res.rows
      this.buildtree(data, this.deptTree, 0)
      this.expandedKeys = data.map((m) => m.parentId)
      this.dataList = data.map((m) => {
        return { key: m.deptId, title: m.deptName }
      })
    })
  },
  methods: {
    // 获取到穿梭框列表
    getMock() {
      getEnterpriseSelectCombox({ userId: this.userId }).then((res) => {
        const targetKeys = []
        const lockData = []
        res.data.map((r) => {
          const data = {
            key: r.enterpriseId,
            title: r.enterpriseName,
            chosen: r.isChoosed, //是否被选择 1是 0否
          }
          if (data.chosen == 1) {
            targetKeys.push(data.key)
          }
          lockData.push(data)
        })
        this.targetKeys = targetKeys
        this.lockData = lockData
      })
    },
    filterOption(inputValue, option) {
      return option.title.indexOf(inputValue) > -1
    },
    // 穿梭框转移变化
    lockChange(targetKeys, direction, moveKeys) {
      // 参数：[已选择]所有选项，方向，移动的选项
      this.targetKeys = targetKeys
    },
    // 锁企权限弹框取消
    handleCancel(e) {
      this.visible1 = false
      this.userId = undefined
    },
    // 锁企权限弹框提交
    handleSubmit() {
      this.confirmLoading = true
      let obj = {
        userId: this.userId, //用户id
        enterpriseId: this.targetKeys.join(','), //企业ids
      }
      addUserPermissionOfEnterprise(obj).then((r) => {
        if (r.code == 0) {
          this.$message.success('配置用户锁企权限成功')
          this.visible1 = false
          this.confirmLoading = false
          this.userId = undefined
        } else {
          this.$message.error('配置用户锁企权限失败')
          this.confirmLoading = false
        }
      })
    },
    // 锁企权限弹框
    lockAuthority(record) {
      this.visible1 = true
      if (record.userId) {
        this.userId = record.userId
        this.getMock()
      }
    },
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    handleEdit(record) {
      this.$refs.modal.edit(record)
    },
    resetPwd(record) {
      this.$refs.pwdmodal.edit(record)
    },
    onChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleOk() {
      this.$refs.table.refresh()
      // console.log('handleSaveOk')
    },
    delByIds(ids) {
      let that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          delUser({ ids: ids.join(',') }).then((res) => {
            if (res.code === 0) {
              that.$message.success(`删除成功`)
              that.handleOk()
            } else {
              that.$message.error(res.msg)
            }
            // const difference = new Set(this.selectedRowKeys.filter(x => !new Set(ids).has(x)))
            // this.selectedRowKeys = Array.from(difference)
            that.selectedRowKeys = []
          })
        },
      })
    },
    onChangeStatus(record) {
      record.status = record.status === '0' ? '1' : '0'
      changUserStatus(pick(record, 'userId', 'status')).then((res) => {
        if (res.code === 0) {
          this.$message.success('保存成功')
        } else {
          this.$message.error(res.msg)
        }
      })
      // 发送状态到服务器
    },
    buildtree(list, arr, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            key: item.deptId,
            value: item.deptId, // value是给modal的select用的，2者属性不一样
            title: item.deptName,
            scopedSlots: { title: 'title' },
            children: [],
          }
          this.buildtree(list, child.children, item.deptId)
          if (child.children.length === 0) {
            delete child.children
          }
          arr.push(child)
        }
      })
    },
    // 下面是树相关方法
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    emitEmpty() {
      this.$refs.searchInput.focus()
      this.searchValue = ''
      this.searchDept()
    },
    getParentKey(key, tree) {
      let parentKey
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i]
        if (node.children) {
          if (node.children.some((item) => item.key === key)) {
            parentKey = node.key
          } else if (this.getParentKey(key, node.children)) {
            parentKey = this.getParentKey(key, node.children)
          }
        }
      }
      return parentKey
    },
    handleChange(e) {
      this.searchDept()
    },
    searchDept() {
      const value = this.searchValue
      const expandedKeys = this.dataList
        .map((item) => {
          if (item.title.indexOf(value) > -1) {
            const parentKey = this.getParentKey(item.key, this.deptTree)
            return parentKey
          }
          return null
        })
        .filter((item, i, self) => item && self.indexOf(item) === i)
      Object.assign(this, {
        expandedKeys,
        autoExpandParent: true,
      })
    },
    handleSelect(selectedKeys, info) {
      this.queryParam = {
        deptId: selectedKeys[0],
      }
      this.$refs.table.refresh(true)
    },
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  },
}
</script>
<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
</style>